/**
 * Product Landing JS
 * handles behavior for product landing page
 *
 */
(function ($) {
    SoyVay.singleRecipe = (function () {
        function privateInit() {
            // Gather a reference to the window
            // Define the max number of characters before reducing font size
            // & the width we check for to see if the user is on mobile (gross)
            const $window = $(window);
            const maxTitleCharacters = 23;
            const detectShrinkWidth = 450;

            // Gathers the product titles and reduces their font size
            function reduceFontSize() {
                // Create a reference to the product box titles on the page
                // Instantiate the number of characters
                const $productBoxTitles = $('.product-box-title');
                let numChars = 0;
                // If there are more characters than the threshold, shrink it
                $productBoxTitles.each(function (i) {
                    numChars = $(this).text().length;
                    if (numChars > maxTitleCharacters) {
                        $(this).css('font-size', '12px');
                    }
                });
            }

            // If the user is on mobile or using a small window
            if ($window.width() <= detectShrinkWidth) {
                reduceFontSize();
            }
        }
        return {
            init() {
                privateInit();
            },
        };
    })();

    // document ready
    $(document).ready(() => {
        SoyVay.singleRecipe.init();
    });
})(jQuery);
